import { type ResourceType, ConditionOperatorEnum, type Provider } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';
import { CLOUD_PROVIDER_PROPERTY, RESOURCE_ID_PROPERTY, RESOURCE_NAME_PROPERTY, RESOURCE_TYPE_PROPERTY } from './propertyNames';
export const useResourceIdentifiers = (providers?: Provider[], resourceTypes?: ResourceType[], nameFilter?: string, includeSaas?: boolean) => {
  const dal = useDAL();
  const condition = useMemo(() => {
    const providersCondition = providers?.length ? [{
      property: CLOUD_PROVIDER_PROPERTY,
      operator: ConditionOperatorEnum.In,
      value: providers
    }] : [];
    const resourceTypeCondition = resourceTypes?.length ? [{
      property: RESOURCE_TYPE_PROPERTY,
      operator: ConditionOperatorEnum.In,
      value: resourceTypes
    }] : [];
    const identifierCondition = nameFilter ? [createCombineCondition([{
      property: RESOURCE_NAME_PROPERTY,
      operator: ConditionOperatorEnum.Contains,
      value: [nameFilter]
    }, {
      property: RESOURCE_ID_PROPERTY,
      operator: ConditionOperatorEnum.Contains,
      value: [nameFilter]
    }], ConditionOperatorEnum.Or)] : [];
    const conditions = [...providersCondition, ...resourceTypeCondition, ...identifierCondition];
    if (conditions.length === 0) {
      return undefined;
    }
    return createCombineCondition(conditions);
  }, [providers, resourceTypes, nameFilter]);
  return dal.inventory.useListResourceIdentifiers(condition, includeSaas);
};